module.exports = __webpack_public_path__ + "assets/images/04_ffdcf94b6ae61f5f4e6e4e2fbbc3b017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/04.png
// module id = 116
// module chunks = 0